import { render } from "./CategoriesNavBar.vue?vue&type=template&id=589b5a8e"
import script from "./CategoriesNavBar.vue?vue&type=script&lang=js"
export * from "./CategoriesNavBar.vue?vue&type=script&lang=js"

import "./CategoriesNavBar.vue?vue&type=style&index=0&id=589b5a8e&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__